Scroller = {

	selected : "",
	el:{},

	init: function(){
		 // return;
		// this.slides = $('[component="directory"] > .row[url]');

		if(window.matchMedia("(max-width: 980px)").matches){
			return;
		}

		this.el = $('[component="page"] content').overlayScrollbars({
		    className: "os-theme-dark",
		    overflowBehavior : {
	    		x : "hidden",
	    	},
		}).overlayScrollbars();

		$('[scrollable]').overlayScrollbars({
			className: "os-theme-dark",
			overflowBehavior : {x:"hidden"},
		    // sizeAutoCapable:false,
		})
	},

	scroll: function(){

		Directory.userScrolling = true;
		// Submenu.update();

		if(Menu.isMobile) return;
		
		Scroller.slides.each(function(index, el) {
			Scroller.checkPositions($(this));
		});
	},

	stopScroll: function(){
		Directory.userScrolling = false;
		Directory.isScrolling = false;
	},

	checkPositions: function(el){

		var top = Math.floor(el.position().top)
		var diff = top - Scroller.el.scroll().y.position

		// if(el.attr('url') == 'lekcie-o-investovani')
		// 	console.log(el.attr('url'), diff);

		if(diff >= 0 && diff <= 150){

			if(this.selected != el.attr('url')){
				this.selected = el.attr('url');
				this.update(el)
			}
		}
	},

	update: function(item){

		if(App.debug){
			console.log('--- Scroller.update -----------------------------');
			console.log('url', item.attr('url'));
		}

		Router.route(item.attr('title'),  item.attr('url'));
	},
}